import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { NotificationsProvider } from "./components/Notifications";
import { DataProvider, useData } from "./providers/DataProvider";

function RootWithPrefs() {
  // This component must be inside DataProvider; we'll render NotificationsProvider inside to use prefs
  const { preferences } = useData();
  return (
    <NotificationsProvider settings={preferences || undefined}>
      <App />
    </NotificationsProvider>
  );
}

const root = createRoot(document.getElementById("root"));
// Determine if DB is configured (helps avoid blank page on deployments without envs)
const isDbConfigured = Boolean(
  process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY
);

if (!isDbConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    "[App] Supabase env not configured. Running in mock/local mode (no persistence)."
  );
}
// Debug: explicit mode log
// eslint-disable-next-line no-console
console.info(`[App] Data mode: ${isDbConfigured ? 'Supabase DB (useDb=true)' : 'Mock/localStorage (useDb=false)'}`);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <DataProvider useDb={isDbConfigured}>
        <RootWithPrefs />
      </DataProvider>
    </ErrorBoundary>
  </StrictMode>
);
